import type { Meta, StoryObj } from "@storybook/react";

import { ResourceType } from "@/constants/Explore";
import type { ExploreResourcesOverviewCardProps } from "@/ui/components/explore/ExploreResourcesOverviewCard";
import ExploreResourcesOverviewCard from "@/ui/components/explore/ExploreResourcesOverviewCard";
import { joinTestIDs } from "@/utils/string.util";

const StoryMeta: Meta<ExploreResourcesOverviewCardProps> = {
  title: "Components/Explore/Resources Overview Card",
  component: ExploreResourcesOverviewCard,
  argTypes: {
    imageUrl: { control: "text" },
    link: { control: "text" },
    testID: { control: "text" },
    title: { control: "text" },
    type: { control: "select", options: Object.values(ResourceType) },
  },
  args: {
    imageUrl: { uri: "https://picsum.photos/800/400" },
    link: "https://equip.health/articles/understanding-eds/atypical-anorexia-nervosa",
    testID: joinTestIDs("explore", "resources", "card"),
    title: "What does Binge Eating Disorder treatment look like at Equip?",
  },
};

type Story = StoryObj<ExploreResourcesOverviewCardProps>;

const Primary: Story = {};

const LongTitle: Story = {
  args: {
    title:
      "What does Binge Eating Disorder treatment look like at Equip? This is a long title that should be truncated.",
  },
};

const Video: Story = {
  args: {
    link: "https://www.youtube.com/watch?v=yKxrKkYLup0&t=9s",
    title: "What is Bulimia?",
    type: ResourceType.Video,
  },
};

export { LongTitle, Primary, Video };
export default StoryMeta;
